import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum, CalculationMethodType, StaffelUnit } from "__generated__/graphql";

export const FeetSchema: RegistryItem = {
	[AgreementTypeEnum.Feet]: {
		defaultValues: {
			calculationMethod: {
				type: CalculationMethodType.Staffel,
				staffelUnit: StaffelUnit.Feet,
			},
		},
		agreementFields: {
			"agreement.manualActionRequired": { rules: { hidden: true } },
		},
		calculationMethodFields: {
			"calculationMethod.type": { rules: { hidden: true } },
		},
	},
};
